<template>
  <!--
    A PRIMEIRA PORTA DO JOGO: escolher a língua, em papel. A versão antiga puxava bandeiras da
    flagcdn.com (uma ida à rede externa antes mesmo de entrar) com 🌍🎮 de enfeite. O nome da
    língua, escrito NELA mesma, é a única bandeira necessária — a mesma decisão das Configurações.
    As classes `language-modal-overlay`/`language-flags` ficam: os testes dirigidos clicam nelas.
  -->
  <div v-if="show" class="language-modal-overlay" role="dialog" aria-label="Idioma / Language">
    <div class="lingua__papel papel-empilhado subir-surgindo">
      <img src="/logotipos/logo-fishbay.png" alt="Fishbay" class="lingua__marca suavizada" />

      <div class="language-flags lingua__opcoes">
        <FishButton
          v-for="lang in availableLanguages"
          :key="lang.code"
          variante="neutro"
          som="clique"
          @click="selectLanguage(lang.code)"
        >
          {{ lang.name }}
        </FishButton>
      </div>
    </div>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n';
import { mapActions } from 'vuex';
import { FishButton } from '@/shared/ui';

export default {
  name: 'ChoiceLanguage',
  components: { FishButton },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close'],
  setup() {
    const { locale } = useI18n();
    return { locale };
  },
  data() {
    return {
      availableLanguages: [
        { code: 'pt', name: 'Português' },
        { code: 'en', name: 'English' },
        { code: 'es', name: 'Español' },
        { code: 'zh', name: '中文' }
      ]
    };
  },
  methods: {
    ...mapActions('language', ['setLanguage']),
    selectLanguage(langCode) {
      // Set the locale in i18n
      this.locale = langCode;

      // Save to store
      this.setLanguage(langCode);

      // Save in localStorage
      localStorage.setItem('userLanguage', langCode);

      // Close the modal
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.language-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: var(--z-modal);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--e-3);
  background: var(--veu);
}

.lingua__papel {
  /* O teto, repetido para o respiro do papel: a porcentagem sozinha mediria o
     véu do modal, que é a tela inteira, e sobrava 126 px para os quatro botões
     — "Português" saía cortado. */
  --folha: 380px;
  width: min(380px, 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--e-4);
}

.lingua__marca {
  width: 96px;
  height: 96px;
  object-fit: contain;
}

.lingua__opcoes {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--e-2);
  width: 100%;
}

@media (max-width: 420px) {
  .lingua__opcoes {
    grid-template-columns: 1fr;
  }
}
</style>
